<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "JISSReport"
}
</script>

<style scoped>

</style>